/**
 * ShapreDataSettings Id
 */
export const SHAPE_DATA_SETTINGS_DATAITEM_ID = 'dataitemsttings';

/**
 * DataItemsRenderer description Id
 */
export const DESCRIPTION_DATAITEM_ID = 'description';